import axiosInstance from './axiosInstance';

export type Privacy = {
  id: string;
  type: string;
  content: string;
};

export type Terms = {
  id: string;
  type: string;
  content: string;
};

export const fetchPrivacy = async (type: string): Promise<Privacy> => {
  const response = await axiosInstance.get<Privacy>(`/api/allbadeum/v1/policy/${type}`);
  console.log('[📦 Fetch result]', response.data);

  if (!response.data || !response.data.content) {
    throw new Error('정책 내용이 비어있습니다');
  }

  return response.data;
};

export const fetchTerms = async (type: string): Promise<Terms> => {
  const response = await axiosInstance.get<Terms>(`/api/allbadeum/v1/policy/${type}`);
  console.log('[📦 Fetch result]', response.data);

  if (!response.data || !response.data.content) {
    throw new Error('정책 내용이 비어있습니다');
  }

  return response.data;
};
